module.exports = __webpack_public_path__ + "static/media/torso-low-right-side.0519a407.png";